module.exports = __webpack_public_path__ + "img/03_uk.4b24cba8.svg";